export enum PlaybackMode {
  LIVE = 'live',
  RESTART = 'restart',
  CATCHUP = 'catchup',
  LIVE360 = 'live360',
}
